import { render } from "./approvalConsoleForm.vue?vue&type=template&id=58228752&scoped=true"
import script from "./approvalConsoleForm.vue?vue&type=script&lang=js"
export * from "./approvalConsoleForm.vue?vue&type=script&lang=js"

import "./approvalConsoleForm.vue?vue&type=style&index=0&id=58228752&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58228752"]])

export default __exports__